export function onClickOutside(element, callback) {
    const handler = (event) => {
        if (!element.contains(event.target)) {
            callback();
        }
    };
    window.addEventListener('click', handler);
    return {
        destroy() {
            window.removeEventListener('click', handler);
        },
    };
}
